import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL Target Tier
export const tierList = (params = '') => Http.get(`/marketing-tiers${serialize(params)}`)
export const tierCreate = (params = '') => Http.post('/marketing-tiers', params)
export const tierByID = (params = '') => Http.get(`/marketing-tiers/${params}`)
export const tierUpdate = (params = '') => Http.put(`/marketing-tiers/${params.id}`, params)
export const tierDestroy = (params = '') => Http.delete(`/marketing-tiers/${params.id}`)
